module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon22.8d76c058.png";